export const initialState = {
  clipboard: '',
  overflowWrap: [],
  leftCol: [],
  midCol: [],
  rightCol: []
};
